<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Box',
    props: {
        value: {
            type: Boolean,
            default: undefined,
        },
        caret: {
            type: String,
            default: 'fa-solid fa-chevron-down',
        },
        headerClass: {
            type: String,
            default: undefined,
        },
        slim: Boolean,
        disable: Boolean,
        readOnly: Boolean,
        fade: Boolean,
        openOnLoad: Boolean,
    },
    data() {
        return {
            open: false,
        }
    },
    computed: {
        ...mapGetters(['lgDevice']),
        isOpen() {
            return this.value !== undefined ? this.value : this.open
        },
    },
    mounted() {
        if (this.openOnLoad) {
            if (this.value !== undefined) this.$emit('input', this.openOnLoad)
            this.open = this.openOnLoad
        }
    },
    methods: {
        toggle: function () {
            if (!this.disable && !this.readOnly) {
                if (this.value !== undefined) {
                    this.$emit('input', !this.value)
                    this.open = this.value
                } else this.open = !this.open
            }
        },
        openBox: function () {
            if (!this.disable && !this.readOnly) {
                this.open = true
                if (this.value !== undefined) this.$emit('input', true)
            }
        },
        closeBox: function () {
            if (!this.disable && !this.readOnly) {
                this.open = false
                if (this.value !== undefined) this.$emit('input', false)
            }
        },
        beforeEnter: function (el) {
            el.style.height = '0'
            el.style.overflow = 'hidden'
            if (this.fade) el.style.opacity = 0
        },
        enter: function (el) {
            this.$nextTick(() => {
                el.style.height = el.scrollHeight + 'px'
                if (this.fade) el.style.opacity = 1
            })
        },
        afterEnter: function (el) {
            el.style.height = 'initial'
            el.style.overflow = ''
            if (this.fade) el.style.opacity = ''
        },
        leave: function (el) {
            el.style.height = el.scrollHeight + 'px'
            el.style.transitionDelay = '50s'
            el.style.overflow = 'hidden'
            if (this.fade) el.style.opacity = 1
            setTimeout(() => {
                el.style.height = '0'
                if (this.fade) el.style.opacity = 0
                el.style.transitionDelay = ''
            }, 50)
        },
        remove(e) {
            e.stopPropagation()
            if (!this.disable) this.$emit('delete')
        },
        edit(e) {
            e.stopPropagation()
            if (!this.disable) this.$emit('edit')
        },
    },
}
</script>

<template lang="pug">
.box(:class="{'box-slim': slim}")
    div(
        v-if="$slots.header"
        @click="toggle"
        :class="[headerClass ? headerClass : 'header', {'p-0': slim, 'cursor-pointer': !readOnly && !disable, 'not-collapsed': isOpen}]")
        slot(name='header')
        transition(name="fade")
            icon.box-caret(v-if="!readOnly && !disable" :class="{'font-size-micro': lgDevice}" :icon="caret" size="xs")
    transition(name='box'
        v-if='!disable'
        @before-enter='beforeEnter'
        @enter='enter'
        @after-enter='afterEnter'
        @leave='leave')
        .box-body(v-show='isOpen || readOnly')
            slot
</template>
